const ONE_HOUR_MS = 60 * 60 * 1000

export type LocationSubscribeResult = "ok" | "item-not-found" | "error"

export type LocationSubscriptionState = {
  lastAttemptAt: number | null
  lastResult: LocationSubscribeResult | null
  msSinceLastAttempt: number | null
  errorsLastHour: number
}

let lastAttemptAt: number | null = null
let lastResult: LocationSubscribeResult | null = null
let errorTimestamps: number[] = []

export const recordLocationSubscribeResult = (
  result: LocationSubscribeResult,
  at: number = Date.now(),
): void => {
  lastAttemptAt = at
  lastResult = result
  if (result === "error") errorTimestamps.push(at)
}

export const getLocationSubscriptionState = (
  now: number = Date.now(),
): LocationSubscriptionState => {
  const cutoff = now - ONE_HOUR_MS
  errorTimestamps = errorTimestamps.filter((t) => t > cutoff)
  return {
    lastAttemptAt,
    lastResult,
    msSinceLastAttempt: lastAttemptAt === null ? null : now - lastAttemptAt,
    errorsLastHour: errorTimestamps.length,
  }
}

export const __resetLocationSubscriptionTrackerForTests = (): void => {
  lastAttemptAt = null
  lastResult = null
  errorTimestamps = []
}
